// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3_kF-","inner":"Form_inner__1TC0c","range":"Form_range__2cY6T","name":"Form_name__1_tnT","actions":"Form_actions__1ky22"};